
import httpClient from './httpClient';

export async function downloadRaterFile(
  stateCode,
  raterFileName,
  raterDriveFileId
) {

  const response = await httpClient.post(
    '/api/audit-premium/download-rater-file',
    {
      stateCode,
      raterFileName,
      raterDriveFileId
    },
    {
      responseType: 'blob'
    }
  );

  const blob = new Blob(
    [response.data],
    {
      type:
        response.headers['content-type'] ||
        'application/octet-stream'
    }
  );

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');

  link.href = url;

  link.download = raterFileName;

  document.body.appendChild(link);

  link.click();

  link.remove();

  window.URL.revokeObjectURL(url);
}